<template>
    <div class="slash-commands">
        <div class="items">
            <div
                v-for="(command, index) of getItems()"
                class="item-card"
                :key="index"
                :ref="`item-card-${index}`"
                :class="{
                    selected: pointerIndex === index,
                    hoverSelected: pointerIndex === index,
                }"
            >
                <div class="title-wrapper">
                    <div class="title">{{ command.title }}</div>
                    <div class="shortcut">{{ command.shortcut }}</div>
                </div>
                <div class="message-preview">{{ command.description }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "Commands",
    data() {
        return {
            command: null,
            pointerIndex: 0,
            cancels: [],
            commands: [
                {
                    title: "Private Message",
                    description: "Leave a private message for the user or contact",
                    shortcut: "pm",
                    alias: ["private-message"],
                },
            ],
        };
    },
    props: {
        defaultCommand: {
            type: String,
        },
        value: {
            type: String,
        },
    },
    mounted() {
        const items = this.getItems();
        this.selectedGroupId = items[0]?._id;
        const itemsEl = document.querySelector(".items");
        const keydownCallback = (e) => {
            console.log("CannedMessageSelector.keydown", e.key);
            if (e.key === "ArrowDown") {
                e.preventDefault();
                if (this.pointerIndex < items.length - 1) {
                    this.pointerIndex++;
                } else {
                    this.pointerIndex = 0;
                }
                itemsEl.childNodes[this.pointerIndex].scrollIntoView({
                    behavior: "smooth",
                });
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                if (this.pointerIndex > 0) {
                    this.pointerIndex--;
                } else {
                    this.pointerIndex = items.length - 1;
                }
                itemsEl.childNodes[this.pointerIndex].scrollIntoView({
                    behavior: "smooth",
                });
            } else if (e.key === "Enter") {
                e.preventDefault();
                this.selected(items[this.pointerIndex]);
            }
        };
        window.addEventListener("keydown", keydownCallback);
        this.cancels.push(() => window.removeEventListener("keydown", keydownCallback));
    },
    created() {
        this.command = this.defaultCommand || "";
    },
    methods: {
        getItems() {
            let commands = this.commands;
            if (this.search?.length > 0) {
                commands = this.commands.filter((command) => {
                    return command.shortcut
                        .toLowerCase()
                        .includes(this.command.toLowerCase() || command.alias.includes(this.command.toLowerCase()));
                });
            }
            return commands;
        },
        selected(command) {
            this.$emit("selected", {
                command: command.shortcut,
                value: this.value,
            });
        },
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    watch: {
        defaultSearch: {
            handler(val, oldVal) {
                if (oldVal !== null) {
                    this.search = val;
                }
            },
        },
    },
});
</script>

<style scoped lang="scss">
.slash-commands {
    width: 100%;
    display: flex;
    height: 100%;
    min-height: inherit;

    .items {
        display: flex;
        flex-direction: column;
        width: 100%;
        background-color: #fff;
        overflow: auto;

        .item-card {
            display: flex;
            flex-direction: column;
            gap: 3px;
            padding: 5px 5px;
            cursor: pointer;
            border-bottom: 1px solid #f1f4f7;

            &:hover,
            &.selected {
                background-color: #f5f5f5;
            }

            &.hoverSelected {
                box-shadow: 2px 2px 2px 2px var(--color-bg-primary-hover);
            }

            .title-wrapper {
                display: flex;
                justify-content: space-between;

                .title {
                    font-size: 14px;
                    font-weight: 500;
                    color: #6c757d;
                }

                .shortcut {
                    font-size: 12px;
                    font-weight: 400;
                    color: #6c757d;
                }
            }

            .message-preview {
                font-size: 12px;
                font-weight: 500;
                color: #6c757d;
                -webkit-line-clamp: 2;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
            }
        }
    }
}
</style>
